// @flow
import PrimaryPalette from '../../colors';

const Theme = {
  default: {
    backgroundColor: PrimaryPalette.white,
    inputColor: PrimaryPalette.darkGreen,
    labelColor: PrimaryPalette.mediumEvergreen,
  },
  active: {
    inputColor: PrimaryPalette.mediumEvergreen,
  },
  disabled: {
    inputColor: PrimaryPalette.darkGrey,
    labelColor: PrimaryPalette.darkerGrey,
  },
  hover: {
    inputColor: PrimaryPalette.lightEvergreen,
  },
};

export default Theme;
